// CSS-grid host for the 6 PulseTiles. 3×2 desktop / 2×3 tablet / 1×6
// mobile, set in styles/trends.css via a media-query staircase. Color
// assignment is stable-per-id so toggling dimensions doesn't reshuffle
// hues.
import PulseTile from './PulseTile';
import { colorFor } from '../util';
import type { PulseTile as TilePayload } from '../types';

interface Props {
  tiles: TilePayload[];
  onSelect?: (tile: TilePayload) => void;
}

// Stable hash-to-hue so a given entity keeps its colour as range/dim toggle.
function hashHue(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

function pickColor(tile: TilePayload, fallbackIndex: number): string {
  if (tile.id === '∅') return '#888888';
  // For countries we use the curated TRENDS_PALETTE rotation by index so
  // adjacent tiles always read as distinct. Actors/families get a hash-pin
  // so the same entity keeps its hue across dimension toggles.
  if (tile.type === 'country') return colorFor(fallbackIndex);
  return colorFor(hashHue(tile.id));
}

export default function PulseGrid({ tiles, onSelect }: Props) {
  if (!tiles || tiles.length === 0) {
    return <div className="trends-chart-empty">No tiles in this window.</div>;
  }
  return (
    <div className="pulse-grid" role="list">
      {tiles.map((tile, i) => (
        <div role="listitem" key={`${tile.type}:${tile.id}`} className="pulse-grid-cell">
          <PulseTile tile={tile} color={pickColor(tile, i)} onSelect={onSelect} />
        </div>
      ))}
    </div>
  );
}
